module.exports = __webpack_public_path__ + "static/media/Delivery-Speed_2.f57df05d.svg";